import { render } from "./ErrorSection.vue?vue&type=template&id=282c3af9"
const script = {}

import exportComponent from "C:\\Users\\berdu\\Documents\\cooweb\\parkfactura-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__